import script from "./BranchDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BranchDetails.vue?vue&type=script&setup=true&lang=js"

import "./BranchDetails.vue?vue&type=style&index=0&id=258d6e0e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-258d6e0e"]])

export default __exports__